export default __webpack_public_path__ + "static/media/animated-card-background.d31daa64.png";